















import {Component, Mixins, Vue} from 'vue-property-decorator'
import {$} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import {AppConfig} from '@/config/app.config'
import RelatorioGeracaoCollection from '@/model/collection/RelatorioGeracaoCollection'

const metaInfo = () => ({
  title: $.t('view.relatorioGeracaoList.title'),
})

@Component({
  metaInfo,
})
export default class RelatorioGeracaoListView extends Mixins(MixinFilter) {
  AppConfig = AppConfig
  readonly RELOAD_INTERVAL = 60000
  intervalId: number | null = null

  collection = new RelatorioGeracaoCollection()

  async created() {
    this.collection.orderBy = 'dataCriacao'
    this.collection.asc = false
  }

  async mounted() {
    this.intervalId = window.setInterval(async () => await this.query(), this.RELOAD_INTERVAL)
  }

  beforeDestroy() {
    if (this.intervalId) {
      window.clearInterval(this.intervalId)
    }
  }
}
